import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { type LotteryRewardName } from '@/common/types/lottery';
import { StringMain, StringXSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';
import { TicketIcon } from '@/components/ui/TicketIcon/TicketIcon';

import { ticketRewardToTier } from '../../config';
import { isTicketPrize, prizeIcon, prizeValueText } from '../../prizes';

import css from './styles.module.scss';

interface OtherRewardItemProps {
  count: string | number;
  name: LotteryRewardName;
  reward: string | number;
}

const OtherRewardItem: FC<OtherRewardItemProps> = ({ count, name, reward }) => {
  const { t } = useTranslation();
  const icon = prizeIcon(name);

  return (
    <div className={css.otherReward}>
      <StringMain weight="bold" className="!text-white/60 !leading-none">
        {count}
      </StringMain>
      <StringXSmall className="!text-white/80 mt-[2px] !leading-none">
        {t('Rewards')}
      </StringXSmall>
      <span className={css.prize}>
        {isTicketPrize(name) ? (
          <TicketIcon type={ticketRewardToTier[name]} className={css.icon} />
        ) : (
          name !== 'usdt' && (
            <Picture
              img={icon.png}
              webp={icon.webp}
              alt={name}
              className={css.icon}
            />
          )
        )}
        {prizeValueText(name, reward)}
      </span>
    </div>
  );
};

export { OtherRewardItem };
